import { ApiFunc, getInstance, getNotAuthInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const letterCreate: ApiFunc<`${typeof API.LETTER}`, 'post'> = data => instance.post(API.LETTER, data)

export const letterIncomingList: ApiFunc<`${typeof API.LETTER_INCOMING}`, 'get'> = data =>
  instance.get(API.LETTER_INCOMING, { params: data })

export const letterOutgoingList: ApiFunc<`${typeof API.LETTER_OUTGOING}`, 'get'> = data =>
  instance.get(API.LETTER_OUTGOING, { params: data })

export const letterDelete: ApiFunc<`${typeof API.LETTER}{id}`, 'delete'> = data =>
  instance.delete(`${API.LETTER}${'id' in data ? data.id : data.name}`)

export const letterStatus: ApiFunc<`${typeof API.LETTER_STATUS}`, 'post'> = data =>
  instance.post(API.LETTER_STATUS, data)

export const letterPublicInfo: ApiFunc<`${typeof API.LETTER_PUBLIC_INFO}`, 'get'> = data =>
  getNotAuthInstance().get(API.LETTER_PUBLIC_INFO, { params: data })
